import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $submitting?: boolean;
  $errors?: any;
}

export const SelectStyles = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    borderRadius: 6,    
    paddingLeft: 10,    
    minHeight:36,
    maxHeight:36,
    paddingRight: 5,         
  }),
  valueContainer: (styles: any, state: any) => ({
    ...styles,
    height: '36px',
    alignItems: 'center', 
    marginLeft:0,
  }),
  menu: (baseStyles: any, state: any) => ({
    ...baseStyles,
    marginTop: 5,   
    backgroundColor: "#fff", 
    position:"absolute",
    zIndex: 99999,
    fontFamily: "Poppins",
  }),
  menuPortal: (baseStyles: any, state: any) => ({ ...baseStyles, zIndex: 9999 }),
  option: (styles: any, state: any) => ({
    ...styles, 
    backgroundColor: state.isSelected ? theme.colors.inputOutline : "", 
    color: theme.colors.black, 
    "&:hover, &.react-select__option--is-focused": {
      ...styles,  
      backgroundColor : state.isSelected ? theme.colors.inputOutline : theme.colors.inputOutline,
      color: theme.colors.black, 
    },
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    padding: 0,
  }),
};

export const InputWrap = styled(Box)<CustomProps>`
  display: flex;
  flex-direction: column;
  position:relative;  
  margin-bottom: 20px;
  max-width: 100%;
  font-size: 14px;
  .react-select__menu{
    font-family: "Poppins";
    .react-select__option{
      &:active{
        background-color: #EBEBEB;
      }
    }
  }
  .react-select__control { 
   .react-select__indicator-separator{
        display:none;
    }
    
    max-width: 100%;
    &.react-select__control--is-focused {
      border: 1px solid ${theme.colors.black}!important;
      box-shadow: none!important;
    }

    &.react-select__control--is-disabled {
      background-color: transparent;
    }

    border: 1px solid ${props => props.$errors ? theme.colors.danger : theme.colors.mdgrey}!important;
    box-shadow: none!important;
    color: ${theme.colors.base_500};  
    & .react-select__value-container {
      padding-top:0;
      padding-bottom:0;
      min-height:35px;
      max-height:35px;
      font-family: "Poppins";
      cursor:pointer;
      padding-left:0;

      & .react-select__single-value--is-disabled{
        color: ${theme.colors.dkgrey};
      }    
    
      & .react-select__input-container {
        & input:focus {
          border:none !important;
        }        
      } 
    }      
    & .react-select__multi-value {
      display: inline-flex;
      align-items: center;
      background-color: #f8f8f8;
      border: 1px solid ${theme.colors.mdgrey};
      border-radius: 999px;
      padding: 0 4px;
      margin: 4px 4px 4px 0;

      .react-select__multi-value__label {
        font-family: "Poppins";
        font-size: 12px;
        color: ${theme.colors.dkgrey};
        padding: 4px 4px 4px 6px;
      }

      .react-select__multi-value__remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: 4px 6px;
        cursor: pointer;
        opacity: 0.8;

        &:hover {
          background: ${theme.colors.base_200};
          opacity: 1;
        }

        svg {
          height: 10px;
          width: 10px;
          fill: ${theme.colors.dkgrey};
        }
      }
    }
    & .react-select__indicator {
      fill: ${theme.colors.base_500};
    }  

    & .react-select__indicator:hover svg {
      cursor: pointer;
      fill: ${theme.colors.body};
      & path {
        fill: ${theme.colors.body};
      }
    }  
  }
`;

export const labelStyles = {
  marginBottom: 0,
  display: "flex",
  justifyContent : "space-between",
  alignItems: "flex-end",
  fontSize: 12,
  fontWeight: 500,
  fontFamily:"Poppins"
};

export const LabelWrapper =  styled.div`
  margin-bottom: 8px;
  display: flex;
  width: 100%;
  label {
    color: ${theme.colors.base_500};
    ${labelStyles}
  }
  small {
    font-style: italic; font-size: .75rem; color: ${theme.colors.ltgrey};
  }
`;



export const Error = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color:${theme.colors.danger};
  margin-top:8px;
  font-size:12px;
  font-weight: 600;
  font-family: "Poppins";

`
